// Import of the module

import { formatNumber } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type View = {
  id: number;
  name: string;
  sort_order: number | null;
  content_url: string;
  workbook_id: number | null;
  hidden_from_tab_bar: boolean;
};

// Definition of the columns

export const views_columns: ColumnDef<View>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "sort_order",
    header: () => <div className="text-right">Display Order</div>,
    cell: ({ row }) => {
      const value = row.getValue("sort_order") as number | null;
      return (
        <div className="text-right">
          {value !== null && value !== undefined ? formatNumber(value) : ""}
        </div>
      );
    },
  },
  {
    accessorKey: "content_url",
    header: "Content URL",
    cell: ({ row }) => {
      const url = row.getValue("content_url") as string;
      return <div className="text-xs lg:whitespace-nowrap">{url}</div>;
    },
  },
  {
    accessorKey: "workbook_id",
    header: "Workbook ID",
    cell: ({ row }) => {
      const value = row.getValue("workbook_id");
      return value !== null && value !== undefined ? value : "";
    },
  },
  {
    accessorKey: "hidden_from_tab_bar",
    header: "Hidden from tab bar",
    cell: ({ row }) => {
      const value = row.getValue("hidden_from_tab_bar") as boolean;
      return <span>{value ? "Yes" : "No"}</span>;
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
